import { render, staticRenderFns } from "./join.vue?vue&type=template&id=aad97410&scoped=true"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"
import style0 from "./join.vue?vue&type=style&index=0&id=aad97410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad97410",
  null
  
)

export default component.exports